(() => {
  const loadBackground = (element) => {
    const mobile = window.matchMedia('(max-width: 749px)').matches;
    const url = mobile ? element.dataset.rmBackgroundMobile : element.dataset.rmBackgroundDesktop;
    if (url) element.style.backgroundImage = `url("${url}")`;
  };

  const loadVideo = (container) => {
    const video = container.matches('video') ? container : container.querySelector('video');
    if (!video) return;

    video.querySelectorAll('source[data-rm-src]').forEach((source) => {
      source.src = source.dataset.rmSrc;
      source.removeAttribute('data-rm-src');
    });

    video.load();
    if (container.dataset.rmAutoplay === 'true') video.play().catch(() => {});
  };

  const targets = document.querySelectorAll(
    '[data-rm-background-mobile], [data-rm-background-desktop], .rm-lazy-video'
  );

  const load = (target) => {
    if (target.classList.contains('rm-lazy-video')) loadVideo(target);
    else loadBackground(target);
  };

  if (!('IntersectionObserver' in window)) {
    targets.forEach(load);
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        load(entry.target);
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '800px 0px' }
  );

  targets.forEach((target) => observer.observe(target));
})();
